import React from 'react';
import { useFamilyContext } from '../../contexts/FamilyContext';
import { formatDistanceToNow } from 'date-fns';

export default function RecentActivityFeed({ limit = 3 }) {
  const { 
    allowanceTransactions, 
    allowanceJobs, 
    family, 
    currentUser,
    recsIdeas 
  } = useFamilyContext();
  
  const isParent = currentUser?.isParent;

  // Collect recent activity items
  const getRecentActivity = () => {
    const activities = [];
    
    // Add recent allowance transactions
    if (allowanceTransactions) {
      Object.entries(allowanceTransactions).forEach(([kidId, transactions]) => {
        const kid = family?.kids?.find(k => k.id === kidId);
        if (kid && transactions) {
          transactions.slice(0, 2).forEach(tx => {
            activities.push({
              id: `tx-${tx.id}`,
              type: 'transaction',
              text: `${kid.name} ${tx.type === 'deduction' ? 'spent' : 'earned'} $${tx.amount} - ${tx.reason}`,
              time: new Date(tx.created_at),
              icon: '💵'
            });
          });
        }
      });
    }

    // Add recently completed jobs
    if (allowanceJobs) {
      allowanceJobs
        .filter(job => job.status === 'completed' || job.status === 'approved')
        .slice(0, 2)
        .forEach(job => {
          const kid = family?.kids?.find(k => k.id === job.accepted_by);
          if (kid) {
            activities.push({
              id: `job-${job.id}`,
              type: 'job',
              text: `${kid.name} completed "${job.title}" for $${job.payment}`,
              time: new Date(job.completed_at || job.updated_at),
              icon: '💵'
            });
          }
        });
    }

    // Add recent ideas/opportunities (for parents)
    if (isParent && recsIdeas) {
      recsIdeas
        .slice(0, 2)
        .forEach(idea => {
          activities.push({
            id: `idea-${idea.id}`,
            type: 'idea',
            text: `New ${idea.category} idea added: "${idea.title}"`,
            time: new Date(idea.created_at),
            icon: '💡'
          });
        });
    }

    // Sort by time and limit results
    return activities
      .sort((a, b) => b.time - a.time)
      .slice(0, limit);
  };

  const recentActivity = getRecentActivity();

  if (recentActivity.length === 0) {
    return null;
  }

  return (
    <div className="recent-activity">
      <div className="activity-header">
        <div className="activity-title">Recent Activity</div>
        <button className="view-all-btn">View All →</button>
      </div>
      
      {recentActivity.map(activity => (
        <div key={activity.id} className="activity-item">
          <div className={`activity-icon ${activity.type}`}>
            {activity.icon}
          </div>
          <div className="activity-content">
            <div className="activity-text">{activity.text}</div>
            <div className="activity-time">
              {formatDistanceToNow(activity.time, { addSuffix: true })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}